import React from 'react';
import styled from '@emotion/styled';
import ManagementReportSearch from '../components/ManagementReport/ManagementReportSearch';
import ManagementReportDataGrid from '../components/ManagementReport/ManagementReportDataGrid';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${props => props.theme.spacing(3)};
  & > :first-of-type {
    margin-bottom: ${props => props.theme.spacing(3)};
  }
`;

const ManagementReport = () => (
  <Container>
    <ManagementReportSearch />
    <ManagementReportDataGrid />
  </Container>
);

export default ManagementReport;
